export default {
  namespaced: true,
  state: {
    show: false,
    component: null,
    size: null,
    props: {}
  },
  mutations: {
    OPEN_MODAL(state, { component, props = {}, size = 'md' }) {
      state.show = true
      state.component = component
      state.props = props
      state.size = size
    },
    CLOSE_MODAL(state) {
      state.show = false
      state.component = null
      state.props = {}
    }
  },
  actions: {
    OPEN_MODAL({ state, commit }, payload) {
      const isAlreadyOpen = state.show

      if (isAlreadyOpen) {
        return
      }

      commit('OPEN_MODAL', payload)
    },
    CLOSE_MODAL({ commit }) {
      commit('CLOSE_MODAL')
    }
  }
}
